import { render } from "./SaveEditedCard.vue?vue&type=template&id=ae7018d6"
import script from "./SaveEditedCard.vue?vue&type=script&lang=js"
export * from "./SaveEditedCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__